const translations = {
  "en": {
    "Drop files here": "Drop files here"
  },
  "zh-tw": {
    "Drop files here": "將檔案拖放至此處"
  }
};

export default translations;
